import { AfterViewInit, Directive, ElementRef, inject, Input } from "@angular/core";
import { CerrixInputValidationErrorsDirective } from "./cerrix-input-validation-errors.directive";
import { CerrixInputValidation } from "./models/cerrix-input-validation.interface";

@Directive({
    selector: "[validationMaxLength]",
    host: {
        "(input)": "onInput()",
    },
})
export class CerrixInputValidationMaxLengthDirective
    implements CerrixInputValidation, AfterViewInit
{
    @Input() validationMaxLength!: number | null;
    @Input() validationMaxLengthKey = "maxlength";
    @Input() validationMaxLengthMessage: string | null = null;
    @Input() validationMaxLengthPriority = 10;

    private inputElement!: HTMLInputElement | HTMLTextAreaElement;

    private elRef: ElementRef<HTMLElement> = inject(ElementRef<HTMLElement>);
    private errors: CerrixInputValidationErrorsDirective | null = inject(
        CerrixInputValidationErrorsDirective,
        { optional: true },
    );
    ngAfterViewInit() {
        this.inputElement = this.findInputElement();
        this.errors.register(this);
    }

    private findInputElement(): HTMLInputElement | HTMLTextAreaElement {
        const native = this.elRef.nativeElement;
        if (native instanceof HTMLInputElement || native instanceof HTMLTextAreaElement) {
            return native;
        }
        return native.querySelector("input, textarea") as HTMLInputElement | HTMLTextAreaElement;
    }

    onInput() {
        this.validate();
    }

    validate() {
        if (!this.inputElement || this.validationMaxLength == null) return;

        const isTooLong = this.inputElement.value.length > this.validationMaxLength;

        if (isTooLong) {
            this.errors?.add({
                key: this.validationMaxLengthKey,
                message:
                    this.validationMaxLengthMessage ??
                    `Input exceeds maximum length of ${this.validationMaxLength} characters`,
                priority: this.validationMaxLengthPriority,
            });
        } else {
            this.errors?.remove(this.validationMaxLengthKey);
        }
    }
}
